import { Avatar as MuiAvatar } from '@mui/material'
import { colorFor, initials } from './color'

export function SenderAvatar({ name, address, size = 32 }: { name?: string | null; address?: string | null; size?: number }) {
  const key = (address || name || '?').toLowerCase()
  return (
    <MuiAvatar aria-hidden sx={{ width: size, height: size, bgcolor: colorFor(key), color: '#fff', fontSize: size * 0.42, fontWeight: 500 }}>
      {initials(name, address)}
    </MuiAvatar>
  )
}
